module.exports = __webpack_public_path__ + "img/hero_sportster_iron_883.e1960931.webp";